
export { default } from './droppable-dimension-publisher';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/droppable-dimension-publisher/index.js
// module id = 1899
// module chunks = 1